import {Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid2';

const DailyEventsSkeleton = () => (
  <Grid
    container
    size={12}
    rowSpacing="1rem"
    mt={1}
    sx={{
      bgcolor: 'background.paper',
      borderRadius: '12px',
    }}>
    <Grid
      size={12}
      p={'12px'}
      display={'flex'}
      justifyContent={'space-between'}
      sx={{
        backgroundColor: 'background.default',
        borderRadius: '12px 12px 0px 0px',
      }}>
      <Grid display={'flex'} alignItems={'center'}>
        <Skeleton variant="circular" width="64px" height="64px" />
        <Grid ml={2}>
          <Skeleton
            variant="rectangular"
            width="60px"
            height={'1rem'}
            sx={{mb: 2}}
          />
          <Skeleton variant="rectangular" width="60px" height={'1rem'} />
        </Grid>
      </Grid>
      <Grid
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}>
        <Skeleton variant="rectangular" width="40px" height={'1rem'} />
        <Skeleton variant="rectangular" width="40px" height={'1rem'} />
      </Grid>
    </Grid>
    <Grid
      size={12}
      px={2}
      pb={2}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'space-between'}>
      <Grid display={'flex'} flexDirection={'column'}>
        <Skeleton
          variant="rectangular"
          width="60px"
          height={'0.8rem'}
          sx={{mb: 2}}
        />
        <Skeleton
          variant="rectangular"
          width="160px"
          height={'0.4rem'}
          sx={{mb: 1}}
        />
        <Skeleton variant="rectangular" width="110px" height={'0.4rem'} />
      </Grid>
      <Grid>
        <Skeleton
          variant="rectangular"
          width="130px"
          height={'31px'}
          sx={{borderRadius: '10px'}}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default DailyEventsSkeleton;
